<template>
    <div>
        <div class="text-right">
            <b-button @click="handleAdd" variant="blue" :disabled="!is_loaded_figure_definition">+ 추가하기</b-button>
        </div>
        
        <div v-show="!is_loaded_figure_definition" :class="[{'d-flex': !is_loaded_figure_definition }, 'justify-content-center align-items-center bg-light p-3']">
            <p class="mb-0"> 불러오는중 </p>
        </div>
        <b-table-simple v-show="is_loaded_figure_definition" hover class="rep-table">
            <b-thead>
                <b-tr>
                    <b-td> No.</b-td>
                    <b-td class="w-100"> Figure Definition </b-td>
                    <b-td> 조정 </b-td>
                </b-tr>
            </b-thead>
            <b-tbody>
                <template v-if="!figure_definitions.length">
                    <b-tr>
                        <b-td colspan="3" class="text-center">
                            <i>없음</i>
                        </b-td>
                    </b-tr>
                </template>
                <template v-else>
                    <b-tr v-for="(fd_item, fd_index) in figure_definitions" :key="fd_item.fd_id">
                        <b-td> {{ fd_index + 1 }}. </b-td>
                        <b-td class="text-left py-2">
                            <h6 class="d-inline">{{ fd_item.figure_code }}. {{ fd_item.figure_name }}. {{ fd_item.data_year }}</h6>
                            <b-dropdown class="ml-3" size="sm" menu-class="figure-definitio-list-dropdown-option">
                                <b-dropdown-item v-for="d_item in figure_dictionaries" :key="d_item.id" @click="selectFigure(d_item, fd_index)"> {{ d_item.figure_code }}. {{ d_item.figure_name }} </b-dropdown-item>
                            </b-dropdown>

                            <p class="f-90 mb-0">Value Definition</p>
                            <b-form-textarea v-model="fd_item.figure_formula" class="mb-2"></b-form-textarea>
                            <p class="f-90 mb-0">Unit Definition</p>
                            <b-form-textarea v-model="fd_item.unit_formula" class="mb-2"></b-form-textarea>
                            <p class="f-90 mb-0">Data Year</p>
                            <b-form-input v-model="fd_item.data_year"></b-form-input>
                        </b-td>
                        <b-td> 
                           <b-button size="sm" @click="handleDelete(fd_index)" variant="dark-border">삭제</b-button>
                        </b-td>
                    </b-tr> 
                </template>  
            </b-tbody>
        </b-table-simple>

        <div class="text-right">
            <b-button variant="blue" class="mr-2" @click="handleSave" :disabled="!is_loaded_figure_definition">저장</b-button>
            <b-button variant="dark" @click="$emit('click-cancel')" :disabled="!is_loaded_figure_definition">취소</b-button>
        </div> 
    </div>
</template>
<script>

export default {
    name: "EditingFigureDefinition",
    props: {
        sub_code: {
            type: String,
            default: ''
        },
        sub_type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            is_loaded_figure_definition: false,
            figure_definitions: [],
            //{ fd_id, figure_code, figure_formula, unit_formula, data_year } 가 있는 배열, 해당 sub_init 관련

            figure_dictionaries: []
            //{ id, figure_code, figure_name, standard_unit } 이 있는 배열. 모든 figure
        }
    },
    async created() {
        this.is_loaded_figure_definition = false
        await this.readFigureUniverse()
        await this.readFigureDefinitions()
        this.is_loaded_figure_definition = true
    },
    beforeDestroy() {
        this.is_loaded_figure_definition = false
    },
    methods: {
        async readFigureUniverse() {
            const response = await this.$axios.get('/read_figure_dictionaries')
            this.figure_dictionaries = []
            response.data.forEach( item => {
                //item: [{ id, figure_code, figure_name, standard_unit }
                this.figure_dictionaries.push(item)
            })
        },
        async readFigureDefinitions() {
            const response = await this.$axios.get('/read_figure_definitions', {
                params: { sub_code: this.sub_code }
            })
            
            this.figure_definitions = []
            if (response.data.code !== 'fail') {
                response.data.value.forEach(item => this.figure_definitions.push(item))
            }
        },
        selectFigure(item,fd_idx){
            let selected_dfn = this.figure_definitions[fd_idx]
            selected_dfn.fd_id = item.id
            selected_dfn.figure_code = item.figure_code
            selected_dfn.figure_name = item.figure_name
            this.figure_definitions.splice(fd_idx, selected_dfn)
        },
        async handleSave () {
            await this.saveFigureDefinitions()
            this.$emit('toast-success','성공','정량데이터 분석로직을 저장하였습니다.')
        },
        async saveFigureDefinitions () {
            const formData = new FormData()
            formData.append('sub_code', this.sub_code)
            formData.append('figure_definitions', JSON.stringify(this.figure_definitions))

            const response =  await this.$axios.post('/save_figure_definitions', formData)
            console.log(response.data)
        },
        handleAdd(){
            let new_item = {
                figure_code: 0,
                figure_name: '',
                figure_formula: '',
                unit_formula: '',
                data_year: 2021
            }
            this.figure_definitions.push(new_item)
        },
        handleDelete(fd_index){
            this.figure_definitions.splice(fd_index, 1)
        }
    }
}
</script>
<style>
.figure-definitio-list-dropdown-option {
    height: 75vh;
    max-height: 700px;
    min-height: 200px;
    overflow: auto;
}

</style>
